<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      v-model="query"
      placeholder="Штатный персонал"
      autocomplete="off"
      @input="onQueryInput"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
      <v-icon v-if="query" name="buttons/cross" :size="11"/>
      <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
      <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">{{ getItemListText(item) }}</div>
        </div>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
import staff from "../../network/staff";

export default {
  name: "StaffSelect",
  mixins: [ staff ],
  props: {
    isDisabled: { type: Boolean, default: false },
    value: { type: Number, default: null },
    state: { type: Boolean, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: '',
      items: [],
      selectedItem: null,
      configureRequestId: 0,
      searchRequestId: 0,
      searchTimer: null,
    }
  },
  mounted() {
    this.getItems();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';

      if (!query) return this.items;

      if (this.selectedItem && this.getItemListText(this.selectedItem).toLowerCase() === query) return this.items;

      return this.items.filter(item => this.getItemListText(item).toLowerCase().includes(query));
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.configure(newValue);
      }, immediate: true
    },
  },
  methods: {
    async configure(id) {
      const requestId = ++this.configureRequestId;

      if (id && id > 0) {
        const result = await this.getStaffById(id);

        if (requestId !== this.configureRequestId) return;

        if (result && result.data) {
          this.query = this.getShortName(result.data.surname, result.data.name, result.data.patronymic);
          this.selectedItem = result.data;
          return;
        }
      }

      this.query = '';
      this.selectedItem = null;
    },
    async getItems(query = '') {
      const requestId = ++this.searchRequestId;
      const result = await this.getStaffsSearch(query.trim());

      if (requestId !== this.searchRequestId) return;

      this.items = (result && result.data) ? result.data : [];
    },
    onFocusIn() {
      this.isFocus = true;
      const selectedName = this.selectedItem ? this.getItemListText(this.selectedItem) : '';
      const query = this.selectedItem && this.query === selectedName ? '' : this.query;
      this.getItems(query);
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        if (this.query !== this.getShortName(this.selectedItem.surname, this.selectedItem.name, this.selectedItem.patronymic)) {
          this.query = this.getShortName(this.selectedItem.surname, this.selectedItem.name, this.selectedItem.patronymic);
        }
      } else {
        this.query = '';
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    async onSelect(item) {
      clearTimeout(this.searchTimer);
      this.query = this.getShortName(item.surname, item.name, item.patronymic);
      const result = await this.getStaffById(item.id);

      if (result && result.data) {
        this.selectedItem = result.data;
      } else {
        this.selectedItem = item;
      }
      this.$emit('onSelect', item.id);
      this.onFocusOut();
    },
    onClear() {
      clearTimeout(this.searchTimer);
      this.query = '';
      this.selectedItem = null;
      this.getItems();
      this.$emit('onSelect', 0, null);
    },
    getItemListText(item) {
      return this.getShortName(item.surname, item.name, item.patronymic);
    },
    getShortName(surname, name, patronymic) {
      const firstCharName = (name || '').slice(0,1);
      const firstCharPatronymic = (patronymic || '').slice(0,1);
      if (firstCharPatronymic === '') {
        return `${surname || ''} ${firstCharName}.`.trim();
      }
      return `${surname || ''} ${firstCharName}. ${firstCharPatronymic}.`.trim();
    },
    onQueryInput(query) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.getItems(query), 250);
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Staff/StaffSelect.vue